import React from 'react'
import { Link } from "react-router-dom";
import Cookies from 'js-cookie'

const Nav = () => (
    <div className="nav">
        <input type="checkbox" id="overlay-input" />
        <label htmlFor="overlay-input" id="overlay-button">
            <span></span>
            <span></span>
            <span></span>
        </label>
        <div id="overlay">
            <ul>
                <li><Link to="/profile">ประวัติ</Link></li>
                <li><Link to="/productbrand">เช็คสินค้า</Link></li>
                <li><Link to="/promotion">โปรโมชั่น</Link></li>
                <li><Link to="/parts">ราคาอะไหล่</Link></li>
                <li><Link to="/download">ดาวน์โหลดเอกสาร</Link></li>
                <li><Link to="/login" onClick={()=>Cookies.remove('user')}>ออกจากระบบ</Link></li>
            </ul>
        </div>
    </div>
)

export { Nav }